<style lang="less">
</style>

<template>
  <el-dialog :title="title" :visible="visible" :before-close="hide">
    <div>
      <div class="flex row">
        <el-input style="max-width:50%" v-model="query.name" placeholder="商品名称">
        </el-input>
        <el-button type="primary" @click="queryCollection" style="width:80px;margin-left:10px">查询</el-button>
        <el-button @click="reset" style="width:80px">重置</el-button>
      </div>
      <el-table max-height="300" tooltip-effect="dark" :header-cell-style="tableHeaderStyle" @selection-change="handleSelectionChange" :data="data" style="margin-top:10px" v-loading="loading">
        <el-table-column type="selection" width="55" class="flex flex-center"></el-table-column>
        <el-table-column label="商品名称">
          <div slot-scope="scope" class="flex row">
            <div class="margin-left-xs">
              <div>{{ scope.row.name }}</div>
              <div class="text-red">¥{{ scope.row.price }}</div>
            </div>
          </div>
        </el-table-column>
        <el-table-column label="商品图片">
          <div slot-scope="scope" class="flex row">
            <img :src="scope.row.mainFileUrl" style="height:50px"/>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="hide">取 消</el-button>
      <el-button type="primary" @click="submit">选择</el-button>
    </span>
  </el-dialog>
</template>

<script>
import action from '@/api/action'

export default {
  props: {
    title: {
      type: String,
      default: "选择商品",
    },
    type: Number,
    instructionId: Number
  },

  data() {
    return {
        data: [],
      selectRows: [],
      loading: false,
      visible: false,
      query: {
        name: '',
      }
    }
  },

  computed: {
  },

  mounted() {
    // this.queryCollection()
  },

  methods: {
    tableHeaderStyle() {
      return "color:#000;font-wight:500;font-size:16px;height:60px;background-color:#e6e9f2;";
    },
    show() {
      this.resetQuery()
      this.visible = true
      this.queryCollection()
    },

    hide() {
      this.visible = false
    },

    submit() {
      this.$emit('submit', this.selectRows)
      this.hide()
    },

    reset() {
      this.resetQuery()
      this.queryCollection()
    },

    resetQuery() {
      this.query = {
        name: ''
      }
    },

    handleSelectionChange(rows) {
      this.selectRows = rows
    },

    async queryCollection() {
      this.selectRows = []
      let query = {};
      if (this.query.name) {
        query.name = `%${this.query.name}%`;
      }
      this.loading = true
        const data =  await action.get('instruction-product', { query: {
        ...query,
        type: this.type,
        instructionId: this.instructionId
    }});
    this.data = data
      this.loading = false
    },
  }
};
</script>